//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.AECDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../Features/Features.AECDesign.MaterialRailingBuilder.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../no/Features.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[1,"AlignmentOffset",0,"Expression",0],[0,"AlignmentType",1,0],[1,"BalusterInterval",0,"Expression",0],[0,"Handrail",1,0],[1,"HandrailHeight",0,"Expression",0],[1,"HandrailOffset",0,"Expression",0],[1,"MaterialRailing",0,"Features.AECDesign.MaterialRailingBuilder",0],[1,"RailingHeight",0,"Expression",0],[1,"ReferenceCurve",0,"Section",0],[1,"ReferenceStair",0,"ScCollector",0],[0,"ReverseHandrailOffsetDirection",1,0],[0,"TopRail",1,0],[0,"Type",1,0]],[],[]];
SPLM.Features.AECDesign.RailingBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AECDesign.RailingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.AECDesign.RailingBuilder.PlacementOptions = Object.freeze({
    "AttachedToStair" : "AttachedToStair", "OnCurve" : "OnCurve"});

SPLM.Features.AECDesign.RailingBuilder.AlignmentTypes = Object.freeze({
    "Left" : "Left", "Center" : "Center", "Right" : "Right", "LeftAndRight" : "LeftAndRight", "OnStringer" : "OnStringer"});

export default SPLM;